import { FormGroup } from '@angular/forms';
import moment from 'moment';

import { MarvInputFile } from '@marv/components';
import { MarvDateService } from '@marv/services';
import { environment } from '@app/environment';
import { RetailerLogo, DatesPreview } from '@app/components';
import { Operation, OperationCustomerPlanningSetting, OrderRequest, ActivityOrder, PlanningMissionPurpose, Order } from '@app/models';

export class OrderDayRecurrenceWeekly {
    weeklyRecurrence: number;
    weeklyDays: Array<number>;
}

export class OrderDayRecurrenceMonthly {
    monthlyRecurrenceDayNum: number;
    monthlyRecurrenceDay: number;
    monthlyRecurrenceMonth: number;
}

export class OrderDayRecurrence {
    startDate: Date;
    endDate: Date;
    periodicity: number;
    recurrenceWeekly?: OrderDayRecurrenceWeekly;
    recurrenceMonthly?: OrderDayRecurrenceMonthly;
}

export class OrderDayDate {
    reccurenceId: string;
    day: Date|null = null;
    startTimeMin: string|null = null;
    startTimeMax: string|null = null;
    timeMorning: string|null = null;
    durationMorning: number|null = null;
    timeAfternoon: string|null = null;
    durationAfternoon: number|null = null;
    hoursEntry: 'IMPOSED'|'SUGGESTED' = 'IMPOSED';
}

export class OrderDayDateConf {
    date: OrderDayDate;
    recurrence?: OrderDayRecurrence;
}

export class OrderDayAgents {
    numAgent: number;
    profilId: number;
    profilName: string;
    workersSuggestionIds: Array<number>;
    suggestion: string|null;
}

export class OrderDayMultipleGoals {
    goalId: number;
    comments: string;
}

export class OrderDayStore {
    id: number;
    name: string;
    retailer: string;
    retailerLogo: RetailerLogo;
    constructor(id: number, name: string, retailer: string){
        this.id = id;
        this.name = name;
        this.retailer = retailer;
        this.retailerLogo = new RetailerLogo(this.retailer);
    }
}

export class OrderDay {
    
    id: string;
    
    // If update
    orderId: number|undefined = undefined;
    // If create
    tabOrdersIds: Array<number> = []; 
    
    disabled: boolean = false;
    operationId: number;
    store: OrderDayStore|null = null;
    customerSectorId: number|null = null;
    nbDays: number = 1;
    datesConf: Array<OrderDayDateConf> = []; 
    datesResults: Array<OrderDayDate> = [];
    finalDatesResults: Array<OrderDayDate> = [];
    datesPreview: DatesPreview = new DatesPreview();
    ordersRequestsByAgents: Map<number, Array<OrderRequest>> = new Map<number, Array<OrderRequest>>;    
    kit: number|null = null;
    nbAgents: number|null = 1;
    agents: Array<OrderDayAgents> = [];    
    enableGoals: boolean = true;  
    uniqueGoal: number|null = null;  
    uniqueGoalComments: string|null = null;  
    multipleGoals: Array<OrderDayMultipleGoals> = [];    
    merchImplementationOption: number;  
    enableRecurrence: boolean = false;  
    enableMissionBrief: boolean = true;
    missionDetailsFile: MarvInputFile|null = null;    
    enableStoreContact: boolean = false;         
    storeContactName: string|null = null;
    storeContactPhone: string|null = null;
    storeContactAccess: string|null = null;
    enableCustomerAppointment: boolean = false;           
    sharingCustomerSectorContactDetailsToWorker: boolean = false;           
    customerAppointmentPlace: string|null = null;
    customerAppointmentTime: string|null = null;
    
    constructor(operationId: number){
        this.id = window.crypto.randomUUID();
        this.operationId = operationId;
    }
        
    static FromForm(orderDay: OrderDay, operation: Operation, operationPlanningSetting: OperationCustomerPlanningSetting, showWorkersSuggestionList: boolean, form: FormGroup, datesPreview: DatesPreview, missionDetailsFile: MarvInputFile|null, contactSharingToWorkerAllowed: boolean): OrderDay{
            
        if(form.controls['nbDays'].value && form.controls['nbDays'].value > 0){
            orderDay.nbDays = form.controls['nbDays'].value;
            let datesConf: Array<OrderDayDateConf> = []; 
            let datesResults: Map<string, OrderDayDate> = new Map<string, OrderDayDate>; 
            for(let i=0;i<form.controls['nbDays'].value;i++){
                
                let numDate = (i+1);  
                let idRecurrence = window.crypto.randomUUID();
                let day = (form.controls['day_'+numDate] ? form.controls['day_'+numDate].value : null);
                let hoursEntry = form.controls['hoursEntry_'+numDate].value;
                
                let startTimeMin = null;
                let startTimeMax = null;
                let timeMorning = null;
                let durationMorning = null;
                let timeAfternoon = null;
                let durationAfternoon = null;
                
                if(hoursEntry === 'SUGGESTED'){
                    startTimeMin = form.controls['startTimeMin_'+numDate].value;
                    startTimeMax = form.controls['startTimeMax_'+numDate].value;
                    durationMorning = form.controls['durationMorning_'+numDate].value;
                }
                else{
                    timeMorning = form.controls['timeMorning_'+numDate].value;
                    durationMorning = form.controls['durationMorning_'+numDate].value;
                    timeAfternoon = form.controls['timeAfternoon_'+numDate].value;
                    durationAfternoon = form.controls['durationAfternoon_'+numDate].value;
                }
                
                let orderDayDate: OrderDayDate = {
                    reccurenceId: idRecurrence,
                    day: day,
                    startTimeMin: startTimeMin,
                    startTimeMax: startTimeMax,
                    timeMorning: timeMorning,
                    durationMorning: durationMorning,
                    timeAfternoon: timeAfternoon,
                    durationAfternoon: durationAfternoon,
                    hoursEntry: hoursEntry
                };
                
                let orderDayDateConf: OrderDayDateConf = {
                    date: orderDayDate
                };
                                
                if(form.controls['enableRecurrence'].value){
                    let datesRecurrence = OrderDay.GetDatesRecurrence(numDate, idRecurrence, form);
                    datesRecurrence.datesResults.forEach(d => {
                        let m = moment(d.day);
                        let k = m.format('YYYY-MM-DD')+' '+d.timeMorning+' '+d.timeAfternoon;
                        if(!datesResults.has(k)){
                            datesResults.set(k, d);
                        }
                    });   
                    orderDayDateConf.recurrence = datesRecurrence.datesConf.recurrence;
                    datesConf.push(orderDayDateConf);                 
                }
                else{
                    if(day){                        
                        let m = moment(day);
                        let k = m.format('YYYY-MM-DD')+' '+timeMorning+' '+timeAfternoon;
                        if(!datesResults.has(k)){
                            datesResults.set(k, orderDayDate);
                        }
                        datesConf.push(orderDayDateConf);
                    }
                }
            }
            let datesResultsArray: Array<OrderDayDate> = [];
            datesResults.forEach(d => {
                datesResultsArray.push(d);
            });
            datesResultsArray.sort((a, b) => {                
                return (a.day && b.day ? a.day?.getTime() - b.day?.getTime() : 0);                
            });
            orderDay.datesConf = datesConf;
            orderDay.datesResults = datesResultsArray;
        }
         
        if(operationPlanningSetting.choseKitOnCustomerMissionPlaning && operation.findActiveKits().length > 0){
            orderDay.kit = form.controls['kit'].value;
        }

        if(form.controls['nbAgents'].value && form.controls['nbAgents'].value > 0){
            orderDay.nbAgents = form.controls['nbAgents'].value;
            let agents: Array<OrderDayAgents> = []; 
            let profils = operation.listActiveProfiles();
            for(let i=0;i<form.controls['nbAgents'].value;i++){
                let numAgent = (i+1);                    
                if(form.controls['agentProfil_'+numAgent]){   
                    let profil = profils.find(p => p.id === form.controls['agentProfil_'+numAgent].value);
                    if(profil){
                        agents.push({
                            numAgent: numAgent,
                            profilId: profil.id,
                            profilName: profil.name,
                            workersSuggestionIds: (showWorkersSuggestionList ? form.controls['agentsSuggestionIds_'+numAgent].value : []),
                            suggestion: form.controls['agentSuggestion_'+numAgent].value
                        });
                    }
                }                      
            }
            orderDay.agents = agents;
        }

        if(operationPlanningSetting.missionPlanningPurposes?.length > 0){
            if(operationPlanningSetting.useMultiPurposePlanning){
                let multipleGoals: Array<OrderDayMultipleGoals> = [];      
                operationPlanningSetting.missionPlanningPurposes.forEach(p => {                    
                    if(form.controls['enableMultipleGoal_'+p.id].value){     
                        multipleGoals.push({
                            goalId: p.id,
                            comments: form.controls['multipleGoalComments_'+p.id].value
                        });
                    }
                });
                orderDay.multipleGoals = multipleGoals;
            }
            else {                
                orderDay.uniqueGoal = form.controls['uniqueGoal'].value;
                orderDay.uniqueGoalComments = form.controls['uniqueGoalComments'].value;
            }
        }
        
        if(operationPlanningSetting.merchImplementationOptions?.length > 0){
            orderDay.merchImplementationOption = form.controls['merchImplementationOption'].value;
        }
        
        orderDay.enableGoals = (orderDay.uniqueGoal !== null || orderDay.uniqueGoalComments !== null || orderDay.multipleGoals.length > 0 || orderDay.merchImplementationOption !== null);
        
        orderDay.enableRecurrence = form.controls['enableRecurrence'].value;

        orderDay.missionDetailsFile = missionDetailsFile;            
        orderDay.enableMissionBrief = (orderDay.missionDetailsFile != null);

        orderDay.enableStoreContact = false;
        orderDay.enableCustomerAppointment = false;
        if(operation.typeOfMission.code != environment.MISSION_TYPE_ANIM){
            orderDay.storeContactName = form.controls['storeContactName'].value;
            orderDay.storeContactPhone = form.controls['storeContactPhone'].value;
            orderDay.storeContactAccess = form.controls['storeContactAccess'].value;            
            orderDay.enableStoreContact = (orderDay.storeContactName != null || orderDay.storeContactPhone != null || orderDay.storeContactAccess != null);

            orderDay.sharingCustomerSectorContactDetailsToWorker = (contactSharingToWorkerAllowed ? form.controls['sharingCustomerSectorContactDetailsToWorker'].value : false);
            orderDay.customerAppointmentPlace = form.controls['customerAppointmentPlace'].value;
            orderDay.customerAppointmentTime = form.controls['customerAppointmentTime'].value;
            orderDay.enableCustomerAppointment = (orderDay.customerAppointmentPlace != null || orderDay.customerAppointmentTime != null);
        }
        
        let finalDatesResults: Array<OrderDayDate> = [];
        let ordersRequestsByAgents: Map<number, Array<OrderRequest>> = new Map<number, Array<OrderRequest>>;
        for(let agent of orderDay.agents){  
            let data = OrderDay.ToOrdersRequests(orderDay, showWorkersSuggestionList, datesPreview, agent);
            ordersRequestsByAgents.set(agent.numAgent, data.ordersRequests);
            finalDatesResults = finalDatesResults.concat(data.finalDatesResults);
        }        
        orderDay.ordersRequestsByAgents = ordersRequestsByAgents;
        orderDay.finalDatesResults = finalDatesResults;
           
        orderDay.datesPreview = datesPreview;
        
        return orderDay;
    }
    
    static ToOrdersRequests(orderDay: OrderDay, showWorkersSuggestionList: boolean, datesPreview: DatesPreview, worker: OrderDayAgents|null = null): {ordersRequests: Array<OrderRequest>, finalDatesResults: Array<OrderDayDate>}{
        
        let ordersRequests: Array<OrderRequest> = [];
        let finalDatesResults: Array<OrderDayDate> = [];
        let activities: Array<ActivityOrder> = [];
        
        let addedDates = new Map<string, boolean>;
        datesPreview.addedDates.forEach(d => {
             addedDates.set(moment(d).format('YYYY-MM-DD'), true);
        });
                
        let deletedDates = new Map<string, boolean>;
        if(datesPreview.deletedDates.length > 0){
            datesPreview.deletedDates.forEach(d => {
                 deletedDates.set(moment(d).format('YYYY-MM-DD'), true);
            });
        }
        
        if(orderDay.datesResults.length > 0){
            for(let date of orderDay.datesResults){
                if(date.day){           
                    let dayStr = moment(date.day).format('YYYY-MM-DD');
                    if(!deletedDates.has(dayStr)){
                        let day = MarvDateService.FromDate(date.day);
                        if(day){

                            let activityOrder: ActivityOrder = new ActivityOrder();
                            activityOrder.day = day;

                            if(date.hoursEntry === 'SUGGESTED'){
                                if(date.startTimeMin){
                                    activityOrder.earliestStartMin = MarvDateService.StrToMinutes(date.startTimeMin); 
                                }
                                if(date.startTimeMax){
                                    activityOrder.latestStartMin = MarvDateService.StrToMinutes(date.startTimeMax); 
                                }                    
                                activityOrder.requestedDurationMin = date.durationMorning;
                            }
                            else{
                                if (date.timeMorning) {
                                    activityOrder.amStartHour = date.timeMorning.split(':')[0];
                                    activityOrder.amStartMin =  date.timeMorning.split(':')[1];
                                    activityOrder.amDurationMin = date.durationMorning;
                                }

                                if (date.timeAfternoon) {
                                    activityOrder.pmStartHour = date.timeAfternoon.split(':')[0];
                                    activityOrder.pmStartMin =  date.timeAfternoon.split(':')[1];
                                    activityOrder.pmDurationMin = date.durationAfternoon;
                                }
                            }
                            
                            activities.push(activityOrder);                            
                            finalDatesResults.push(date);
                        }
                    }
                    
                    if(addedDates.has(dayStr)){
                        addedDates.delete(dayStr);
                    }
                }
            }
        }
        
        addedDates.forEach((v, k) => {
            
            let m = moment(k);
            let conf = (orderDay.datesConf.length > 0 ? orderDay.datesConf[0] : null);
            let day = MarvDateService.FromDate(m.toDate());
            
            if(conf && day){
                let activityOrder: ActivityOrder = new ActivityOrder();
                activityOrder.day = day;
                
                if(conf.date?.hoursEntry === 'SUGGESTED'){
                    if(conf.date?.startTimeMin){
                        activityOrder.earliestStartMin = MarvDateService.StrToMinutes(conf.date.startTimeMin); 
                    }
                    if(conf.date?.startTimeMax){
                        activityOrder.latestStartMin = MarvDateService.StrToMinutes(conf.date.startTimeMax); 
                    }                    
                    activityOrder.requestedDurationMin = conf.date.durationMorning;
                }
                else{
                    if (conf.date?.timeMorning) {
                        activityOrder.amStartHour = conf.date.timeMorning.split(':')[0];
                        activityOrder.amStartMin =  conf.date.timeMorning.split(':')[1];
                        activityOrder.amDurationMin = conf.date.durationMorning;
                    }

                    if (conf.date?.timeAfternoon) {
                        activityOrder.pmStartHour = conf.date.timeAfternoon.split(':')[0];
                        activityOrder.pmStartMin =  conf.date.timeAfternoon.split(':')[1];
                        activityOrder.pmDurationMin = conf.date.durationAfternoon;
                    }
                }
                                
                activities.push(activityOrder);
                
                finalDatesResults.push({
                    reccurenceId: window.crypto.randomUUID(),
                    day: m.toDate(),
                    startTimeMin: conf.date.startTimeMin,
                    startTimeMax: conf.date.startTimeMax,
                    timeMorning: conf.date.timeMorning,
                    durationMorning: conf.date.durationMorning,
                    timeAfternoon: conf.date.timeAfternoon,
                    durationAfternoon: conf.date.durationAfternoon,
                    hoursEntry: conf.date.hoursEntry 
                });
            }
        });        
        
        let orderRequest = new OrderRequest();

        if(orderDay.store){            
            orderRequest.store = orderDay.store.id;
        }

        orderRequest.operation = orderDay.operationId;
        orderRequest.missionOrderSource = 'LOCUPA';
        orderRequest.customerSector = orderDay.customerSectorId;    

        if(worker){                
            orderRequest.profil = worker.profilId;
            orderRequest.profilName = worker.profilName;  
            orderRequest.workerIdsToOfferMission = (showWorkersSuggestionList && worker.workersSuggestionIds ? worker.workersSuggestionIds : []);           
            if(worker.suggestion){    
                orderRequest.reco = worker.suggestion;
            }
        }

        // A MODIFIER - Gestion des tournées
        //orderRequest.dailyTourPlanning;

        if(orderDay.kit){
            orderRequest.kit = orderDay.kit;
        }

        let plannedP: Array<PlanningMissionPurpose> = [];
        if(orderDay.uniqueGoal){            
            let newPP = new PlanningMissionPurpose();
            newPP.purposeId = orderDay.uniqueGoal;
            if(orderDay.uniqueGoalComments !== null){
                newPP.instructions = orderDay.uniqueGoalComments;
            }
            plannedP.push(newPP);            
        }
        if (orderDay.multipleGoals.length > 0) {            
            for (let g of orderDay.multipleGoals) {                    
                    let newPP = new PlanningMissionPurpose();
                    newPP.purposeId = g.goalId;
                    newPP.instructions = g.comments;
                    plannedP.push(newPP);                    
            }            
        }        
        orderRequest.plannedPurposes = plannedP;

        if(orderDay.merchImplementationOption){
            orderRequest.merchImplementationOption = orderDay.merchImplementationOption;
        }

        orderRequest.csPresence = orderDay.enableCustomerAppointment;
        if(orderDay.customerAppointmentPlace){
            orderRequest.appointment = orderDay.customerAppointmentPlace;
        }
        if(orderDay.customerAppointmentTime){
            orderRequest.appointmentHour = orderDay.customerAppointmentTime.split(":")[0];
            orderRequest.appointmentMin = orderDay.customerAppointmentTime.split(":")[1];
        }

        orderRequest.sharingCustomerSectorContactDetailsToWorker = orderDay.sharingCustomerSectorContactDetailsToWorker;

        if(orderDay.storeContactName){
            orderRequest.storeContact = orderDay.storeContactName;
        }
        if(orderDay.storeContactPhone){
            orderRequest.mobileStoreContact = orderDay.storeContactPhone;
        }
        if(orderDay.storeContactAccess){
            orderRequest.storeAccess = orderDay.storeContactAccess;
        }

        orderRequest.planning = activities;

        ordersRequests.push(orderRequest);

        return {ordersRequests: ordersRequests, finalDatesResults: finalDatesResults};
    }
    
    static GetDatesRecurrence(numDate: number, idRecurrence: string, form: FormGroup): {datesConf: OrderDayDateConf, datesResults: Array<OrderDayDate>}{
                
        let datesConf: OrderDayDateConf = new OrderDayDateConf();
        let datesResults: Array<OrderDayDate> = []; 
         
        let startDate = form.controls['recurrence_start_date_'+numDate].value;
        let endDate = form.controls['recurrence_end_date_'+numDate].value;
        let periodicity = form.controls['periodicity_'+numDate].value;
        let hoursEntry = form.controls['hoursEntry_'+numDate].value;
        
        let startTimeMin = null;
        let startTimeMax = null;
        let timeMorning = null;
        let durationMorning = null;
        let timeAfternoon = null;
        let durationAfternoon = null;

        if(hoursEntry === 'SUGGESTED'){
            startTimeMin = form.controls['startTimeMin_'+numDate].value;
            startTimeMax = form.controls['startTimeMax_'+numDate].value;
            durationMorning = form.controls['durationMorning_'+numDate].value;
        }
        else{
            timeMorning = form.controls['timeMorning_'+numDate].value;
            durationMorning = form.controls['durationMorning_'+numDate].value;
            timeAfternoon = form.controls['timeAfternoon_'+numDate].value;
            durationAfternoon = form.controls['durationAfternoon_'+numDate].value;
        }
        
        if(startDate && endDate && periodicity){
            
            let recurrence = new OrderDayRecurrence();
            recurrence.startDate = startDate;
            recurrence.endDate = endDate;
            recurrence.periodicity = periodicity;
            
            startDate.setHours(0, 0, 0);
            let start = moment(startDate);
            endDate.setHours(23, 59, 59);
            let end = moment(endDate);
            
            switch(periodicity){
                case 1:
                
                    let weekDays = MarvDateService.GetWeekDays();
                    let weekDaysRecurrence: Array<number> = [];
                    let weeklyRecurrence = form.controls['weekly_recurrence_'+numDate].value;
                    
                    for(let wd of weekDays){
                        if(form.controls['weekly_day_'+numDate+'_'+wd.numDay].value){
                            weekDaysRecurrence.push(wd.numDay);
                        }
                    }
                    
                    if(weeklyRecurrence && weekDaysRecurrence.length > 0){
                        
                        while(start <= end){
                            if(weekDaysRecurrence.indexOf(start.isoWeekday()) !== -1){
                                datesResults.push({
                                    reccurenceId: idRecurrence,
                                    day: start.toDate(),
                                    startTimeMin: startTimeMin,
                                    startTimeMax: startTimeMax,
                                    timeMorning: timeMorning,
                                    durationMorning: durationMorning,
                                    timeAfternoon: timeAfternoon,
                                    durationAfternoon: durationAfternoon,
                                    hoursEntry: hoursEntry
                                });
                            }
                            if(start.isoWeekday() === 7
                                && weeklyRecurrence > 1){
                                start.add(7 * (weeklyRecurrence-1), 'days');
                            }
                            start.add(1, 'day');
                        }
                    }
                    
                    let recurrenceWeekly = new OrderDayRecurrenceWeekly();
                    recurrenceWeekly.weeklyRecurrence = weeklyRecurrence;
                    recurrenceWeekly.weeklyDays = weekDaysRecurrence;
                    recurrence.recurrenceWeekly = recurrenceWeekly;
                    
                    break;
                case 2:
                                    
                    let monthlyRecurrenceDayNum = form.controls['monthly_recurrence_day_num_'+numDate].value;
                    let monthlyRecurrenceDay = form.controls['monthly_recurrence_day_'+numDate].value;
                    let monthlyRecurrenceMonth = form.controls['monthly_recurrence_month_'+numDate].value;
                
                    if(monthlyRecurrenceDayNum && monthlyRecurrenceDay && monthlyRecurrenceMonth){
                        let startMonth = moment(MarvDateService.GetFirstDayOfMonth(start.toDate()));
                        while(startMonth <= end){                            
                            let nthDay = MarvDateService.GetNthWeekdayOfMonth(startMonth.toDate(), monthlyRecurrenceDayNum, monthlyRecurrenceDay);
                            if(nthDay){
                                let mNthDay = moment(nthDay);
                                if(start.format('YYYY-MM-DD') <= mNthDay.format('YYYY-MM-DD') && mNthDay.format('YYYY-MM-DD') <= end.format('YYYY-MM-DD')){
                                    datesResults.push({
                                        reccurenceId: idRecurrence,
                                        day: mNthDay.toDate(),
                                        startTimeMin: startTimeMin,
                                        startTimeMax: startTimeMax,
                                        timeMorning: timeMorning,
                                        durationMorning: durationMorning,
                                        timeAfternoon: timeAfternoon,
                                        durationAfternoon: durationAfternoon,
                                        hoursEntry: hoursEntry
                                    });
                                }
                                
                            }
                            
                            startMonth.add(monthlyRecurrenceMonth, 'months');
                            startMonth = moment(MarvDateService.GetFirstDayOfMonth(startMonth.toDate()));
                        }
                        
                    }
                    
                    let recurrenceMonthly = new OrderDayRecurrenceMonthly();
                    recurrenceMonthly.monthlyRecurrenceDayNum = monthlyRecurrenceDayNum;
                    recurrenceMonthly.monthlyRecurrenceDay = monthlyRecurrenceDay;
                    recurrenceMonthly.monthlyRecurrenceMonth = monthlyRecurrenceMonth;
                    recurrence.recurrenceMonthly = recurrenceMonthly;
                
                    break;
            }
            
            datesConf.recurrence = recurrence;
            
        }
        
        return { 
            datesConf: datesConf, 
            datesResults: datesResults
        };
    }
    
    static FromOrder(o: Order, operationPlanningSetting: OperationCustomerPlanningSetting): OrderDay {
        let orderDay = new OrderDay(o.operation.id);
        
        orderDay.id = window.crypto.randomUUID();   
        orderDay.orderId = o.id;     
        orderDay.store = {  
            id: o.location.id,
            name: o.location.name,
            retailer: o.location.retailer.name,
            retailerLogo: new RetailerLogo(o.location.retailer.name)
        }
        orderDay.customerSectorId = o.location.customerSector;        
        orderDay.nbDays = o.activities.length;
       
        if(o.activities){
            for(let a of o.activities){
                
                let timeMorning = null;
                let durationMorning = null;
                let timeAfternoon = null;
                let durationAfternoon = null;
                let startTimeMin = (a.earliestStartMin != null ? MarvDateService.MinutesToStr(a.earliestStartMin) : null);
                let startTimeMax = (a.latestStartMin != null ? MarvDateService.MinutesToStr(a.latestStartMin) : null);
                let hoursEntry: 'IMPOSED'|'SUGGESTED' = (startTimeMin !== null && startTimeMax !== null ? 'SUGGESTED' : 'IMPOSED');
                
                if(hoursEntry === 'SUGGESTED'){
                    durationMorning = a.requestedDurationMin;
                }
                else{
                    startTimeMin = null;
                    startTimeMax = null;
                    timeMorning = (a.amStartTime ? moment(a.amStartTime).format("HH:mm") : null);
                    durationMorning = (a.amStartTime && a.amEndTime ? MarvDateService.GetDuration(a.amStartTime, a.amEndTime) : null);
                    timeAfternoon = (a.pmStartTime ? moment(a.pmStartTime).format("HH:mm") : null);
                    durationAfternoon = (a.pmStartTime && a.pmEndTime ? MarvDateService.GetDuration(a.pmStartTime, a.pmEndTime)  : null);
                }                
                                
                orderDay.datesConf.push({
                    date: {
                        day: MarvDateService.ToDate(a.day),
                        startTimeMin: startTimeMin,
                        startTimeMax: startTimeMax,
                        timeMorning: timeMorning,
                        durationMorning: durationMorning,
                        timeAfternoon: timeAfternoon,
                        durationAfternoon: durationAfternoon,    
                        hoursEntry: hoursEntry,                
                        reccurenceId: window.crypto.randomUUID()
                    }
                });
            }
        }
       
        orderDay.kit = o.kit?.id || null;
        orderDay.nbAgents = 1;
        
        if(o.profil){
            let orderDayAgents: OrderDayAgents = {
                profilId: o.profil.id,
                profilName: o.profil.name,
                workersSuggestionIds: o.workerIdsBeingOfferedMission,
                suggestion: o.comment,
                numAgent: 1
            };
            orderDay.agents = [orderDayAgents];
        }
        
        if(o.plannedPurposes?.length > 0){ 
            if(operationPlanningSetting.useMultiPurposePlanning){
                for(let p of o.plannedPurposes){
                    orderDay.multipleGoals.push({
                        goalId: p.purposeId,
                        comments: p.instructions
                    });
                } 
            }
            else{
                if(!orderDay.uniqueGoal){
                    orderDay.uniqueGoal = o.plannedPurposes[0].purposeId;
                    orderDay.uniqueGoalComments = o.plannedPurposes[0].instructions;
                }                     
            }      
        }
        orderDay.enableGoals = (orderDay.uniqueGoal !== null || orderDay.uniqueGoalComments !== null || orderDay.multipleGoals.length > 0 || orderDay.merchImplementationOption !== null);  
        
        if(o.merchImplementationOption){
            orderDay.merchImplementationOption = o.merchImplementationOption.id;  
        }
        
        if(o.briefDocument){
            let file = new MarvInputFile();  
            file.filename = o.briefDocument?.sourceFileName;
            orderDay.missionDetailsFile = file;
        }
        orderDay.enableMissionBrief = (orderDay.missionDetailsFile !== null);
             
        orderDay.storeContactName = o.storeContact;
        orderDay.storeContactPhone = o.mobileStoreContact;
        orderDay.storeContactAccess = o.storeAccess;        
        orderDay.enableStoreContact = (orderDay.storeContactName !== null || orderDay.storeContactPhone !== null || orderDay.storeContactAccess !== null);    
              
        orderDay.sharingCustomerSectorContactDetailsToWorker = o.sharingCustomerSectorContactDetailsToWorker;   
        orderDay.customerAppointmentPlace = o.appointment;
        if(o.appointmentTime){
            orderDay.customerAppointmentTime = moment(o.appointmentTime).format("HH:mm");
        }        
        orderDay.enableCustomerAppointment = (orderDay.customerAppointmentPlace !== null || orderDay.customerAppointmentTime !== null);     
        
        return orderDay;
    }
    
    getCopy(newId: boolean = true): OrderDay{
        let copy = new OrderDay(this.operationId);        
        Object.assign(copy, this);
        if(newId){
            copy.id = window.crypto.randomUUID();            
        }
        copy.disabled = false;
        copy.tabOrdersIds = [];
        copy.finalDatesResults = [];
        return copy;
    }
}
